import { Reveal, LineReveal } from "./Reveal";

const CHAPTERS = [
  { n: "I", title: "La fiabilité avant la nouveauté", text: "Nous ne vendons pas ce qui brille : nous vendons ce qui tient. Chaque machine est testée, configurée et garantie avant de quitter nos rayons." },
  { n: "II", title: "Le logiciel au service du métier", text: "Un bon logiciel de gestion disparaît derrière votre travail. Nous concevons des outils sobres, rapides et pensés pour vos équipes, pas pour les démos." },
  { n: "III", title: "Un engagement de proximité", text: "Installés à Dakar, nous répondons vite, en français ou en wolof, et nous restons là après la vente. La confiance se construit sur la durée." },
];

export const Manifesto = () => (
  <section data-testid="manifesto-section" className="grain relative bg-navy py-20 text-white lg:py-28">
    <div className="relative z-10 mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 sm:px-8 lg:grid-cols-12 lg:px-16">
      <div className="lg:col-span-4">
        <div className="lg:sticky lg:top-32">
          <p className="eyebrow text-gold">03 — Manifeste</p>
          <LineReveal inView className="mt-4 font-display text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl" lines={["Trois principes,", <span className="font-serif italic font-medium text-gold">une seule maison.</span>]} />
        </div>
      </div>
      <div className="lg:col-span-8">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.08} className="group grid grid-cols-[72px_1fr] gap-6 border-t border-white/10 py-10 last:border-b sm:grid-cols-[120px_1fr]" data-testid={`manifesto-chapter-${i + 1}`}>
            <span className="font-serif text-4xl italic text-gold/80 transition-colors duration-500 group-hover:text-gold sm:text-6xl">{c.n}</span>
            <div>
              <h3 className="font-display text-xl font-semibold sm:text-2xl">{c.title}</h3>
              <p className="mt-4 max-w-2xl text-base leading-relaxed text-white/65">{c.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
